import script from "./AddPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddPage.vue?vue&type=script&lang=ts&setup=true"

import "./AddPage.vue?vue&type=style&index=0&id=0f0a1d8d&lang=css"

const __exports__ = script;

export default __exports__